<template>
  <form-layout :label="label">
    <info-alert :message="message" />
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout'
import InfoAlert from "@/views/atoms/alerts/InfoAlert";

export default {
  name: "InfoAlertBrowseItem",
  components: {
    FormLayout,
    InfoAlert,
  },
  props: {
    label: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true,
    }
  },
}
</script>
